<template>
  <div class="product-wrap">
    <transition name="fade" mode="out-in">
      <div class="row" v-if="!imgLoading">
        <div class="product-cards custom-product-cards"
          :style="$root.pageName === 'Cart' ? 'justify-content: flex-start;' : ''">
          <product
            v-for="(product, index) in customProducts"
            class="custom-product-card"
            :key="product.id"
            :product="product"
            :index="index"
            :orderFreeSwatchBtn="true"
            :isSearchPage="false"
            @add-swatch-to-cart="addSwatchToCart"
          />
          <!-- <div class="product-card custom-product-card" v-for="color in customProducts">
            <a :href="color.url">
              <div class="product-card-img">
                <img class="img-effect" src="/img/spinner.gif" v-if="imgLoading">
                <img class="img-effect" :src="color.featured_image_url" :alt="color.name" v-if="!imgLoading && color.featured_image_url">
                <img class="img-effect" src="/img/default-product-img.png?size=200" alt="image coming soon"
                  v-else-if="!imgLoading && !color.featured_image_url">
              </div>
            </a>
            <a :href="color.url">
              <div class="product-card-details">
                <h3 class="product-title">{{ color.name }}</h3>
                <span class="product-sku">{{ color.sku }}</span>
                <span class="product-price">{{ color.start_price.formatted }}/{{ color.base_quantity.unit === 'item' ?
                  'ea' : 'lb'
                }}</span>
              </div>
            </a>
            <div class="product-card-btn" v-if="!color.discontinued">
              <a class="btn btn-blue product-btn" :href="color.url">View Details</a>
              <button class="btn btn-orange product-btn"
                v-if="color.swatch_product.enabled && !color.swatch_product.hero_only && !color.discontinued"
                :onclick="`dataLayer.push({'sku': '${color.sku}', 'event' : 'swatchAddToCart'});`"
                @click.prevent="quickAddSwatch(color)">
                Order Free Swatch
              </button>
            </div>
            <div class="product-card-btn" v-else>
              <a class="btn btn-black product-btn" :href="color.url">Discontinued</a>
            </div>
          </div> -->
        </div>
      </div>
    </transition>
    <div class="text-center" v-if="!useLoader && imgLoading">
      <Spinner color="#3982c4" />
    </div>
    <div v-if="!imgLoading && customProducts.length === 0">
      <div class="text-center">
        <h3 v-if="allcats === 'pris_featured'"><i class="fa fa-frown-o" aria-hidden="true"></i>&nbsp;Sorry. No Featured
          Products</h3>
        <h3 v-else><i class="fa fa-frown-o" aria-hidden="true"></i>&nbsp;Sorry. No Deals Today</h3>
        <br>
        <a href="/shop/powder-coating-colors" class="btn btn-blue">Continue To Shop</a>
      </div>
    </div>

    <infinite-loading spinner="waveDots" :identifier="infiniteId" @infinite="onInfinite" :distance="20" v-if="useLoader">
      <div class="no-more" slot="no-more" v-if="Object.keys(customProducts).length <= 0">
        <i class="fa fa-search" aria-hidden="true"></i>
        <h4>No items were found.</h4>
      </div>
      <div slot="no-more" v-else></div>
    </infinite-loading>
  </div>
</template>

<script>
import images from '../../mixins/images.js';
import Spinner from '../Spinner.vue';
import Product from "../shop/products/Product.vue";
import InfiniteLoading from 'vue-infinite-loading';

export default {
  name: 'custom-product-list',

  props: {
    limit: Number || 6,
    allcats: String || 'pris_all_colors'
  },

  components: {
    Spinner,
    Product,
    InfiniteLoading
  },

  mixins: [images],

  data() {
    return {
      customProducts: [],
      imgLoading: true,
      queryParams: {},
      infiniteId: +new Date(),
      showFooter: this.$root.showFooter || false,
    }
  },

  computed: {
    useLoader() {
      if (this.$root.pageName && this.$root.pageName !== 'Home' && this.$root.pageName !== 'Cart') {
        return true;
      }

      return false;
    }
  },

  mounted() {
    if (!this.useLoader) {
      this.onInfinite();
    }
  },

  methods: {
    quickAddSwatch(color) {
      this.$root.addSwatchToCart(color);
    },

    addSwatchToCart(swatch) {
      this.$emit("add-swatch-to-cart", swatch);
    },

    onInfinite($state) {
      const customProductUrl = `api/proxify/domains/prismatic/shop/products`;

      if (!this.queryParams.hasOwnProperty('page')) {
        this.queryParams = {
          fields: 'featured_image_url,name,id,url,sku,stock_level,pricing.**,start_price.**,base_quantity.**,swatch_product.**,categories.code',
          limit: this.limit,
          allcats: this.allcats,
          orderBy: 'rank',
          orderdir: 'desc',
          hide_discontinued: false,
          excludecat: 'pris_akzonobel',
        }
      }

      axios.get(customProductUrl, { params: this.queryParams })
        .then(({ data: response }) => {
          this.customProducts = [...this.customProducts, ...response.data];

          if (this.useLoader) {
            if (!response) {
              $state.complete();
              return;
            }

            if (!response.data.length) {
              $state.complete();
            }

            this.queryParams.page = response.pagination.page + 1;

            $state.loaded();
          }
        })
        .catch(response => {
          console.log(response);
        })
        .finally(() => {
          setTimeout(() => {
            this.imgLoading = false;
          }, 1000);
        });
    }
  },
}
</script>

<style lang="scss" scoped>
.product-wrap {
  padding: 15px;

  .custom-product-cards {
    justify-content: center;
    flex-wrap: wrap;
    display: flex;

    .custom-product-card {
      flex: 0 0 calc(25%);
    }
  }

  #loading-products {
    font-size: 60px;
    text-align: center;
    position: relative;
    height: 10vh;
  }

  @media screen and (max-width: 768px) {
    .custom-product-cards {
      display: grid;
    }
  }
}
</style>
